import React, { Component } from 'react';

// TODO create an issue to fix the twitter timeline issue
class TwitterFeed extends Component {
  render() {
    return (
      <div>
        <div className="container mb-4">
          <div className="feedBox">
            {/* // check for valid & updated npm library to render a twitter timeline componnent  */}
          </div>
        </div>
      </div>
    );
  }
}

export default TwitterFeed;
